import { useTranslation } from "react-i18next";
import { FiClipboard } from "react-icons/fi";
import { EventDataDto, PublicContextDto } from "../../../autogen/bff-api";
import { useDisplayDate } from "../../../common/formatting/useDisplayDate";
import { formatEstimatedValue } from "../../sourcing-events/portal/utils/displayFormatters";
import { LabelValueGrid } from "../../sourcing-events/portal/view-single/LabelValueGrid";
import { SectionCard } from "../../sourcing-events/portal/view-single/SectionCard";

const DASH = "–";

export const ContractSection = ({
  eventData,
  publicContext,
}: {
  eventData: EventDataDto;
  publicContext: PublicContextDto;
}) => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();
  const duration = eventData.contractDuration;
  const value = publicContext.estimatedValue;

  let durationValue: string = DASH;
  if (duration) {
    if (duration.startDate || duration.endDate) {
      durationValue = `${duration.startDate ? displayDate(duration.startDate) : "?"} – ${
        duration.endDate ? displayDate(duration.endDate) : "?"
      }`;
    } else if (duration.periodMonths != null) {
      durationValue = `${duration.periodMonths} ${t("months")}`;
    }
  }

  return (
    <SectionCard icon={FiClipboard} title={t("Contract")}>
      <LabelValueGrid
        rows={[
          {
            label: t("Estimated value"),
            value: value?.value != null ? formatEstimatedValue(value.value, value.currency) : DASH,
          },
          { label: t("Contract duration"), value: durationValue },
        ]}
      />
    </SectionCard>
  );
};
